<template>
  <div class="page">
    <yy-header />
    <swiper class="swiper-container swiper-no-swiping" ref="mySwiper" :options="swiperOptions">
      <swiper-slide class="swiper-slide swiper-slide-1">
        <div class="content">
          <div class="tt">公司介绍</div>
          <div class="desc">
            江苏微影邦影视科技有限公司2018年3月成立于阳澄湖畔，是一家从事影视生态及数字图形图像产品研发的创新型企业，全景数字化治理应用领跑者。国内首创SaaS环境监测治理服务应用——“鹰眼系统”，是面向政府、企业及特种领域用户使用的AI智慧全景虚拟现实产品，为用户提供成本低、易部署、时效性强的应用方案，在农村人居环境治理、河湖治理、城市环境治理、群租厂房整治、应急管理、交通、建设等与空间相关领域应用广泛。
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide swiper-slide-2">
        <div class="content">
          <div class="tt">项目合作</div>
          <div class="row">
            <div class="item">
              <div class="row-tt">联系电话</div>
              <div class="row-desc">18015533338</div>
            </div>
            <div class="item">
              <div class="row-tt">电子邮箱</div>
              <div class="row-desc">yangkun@vyb.cn</div>
            </div>
          </div>
          <div class="address">江苏微影邦影视科技有限公司</div>
          <div class="address-detail">江苏省昆山市玉山镇祖冲之南路1666号清华科技园10号楼</div>
        </div>
        <yy-footer />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import yyHeader from '../components/yy-header';
import yyFooter from '../components/yy-footer';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import 'animate.css';

export default {
  components: { yyHeader, yyFooter, Swiper, SwiperSlide },

  data() {
    let _this = this;
    return {
      swiperOptions: {
        speed: 800,
        direction: 'vertical',
        slidesPerView: 1,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    };
  },

  methods: {},
};
</script>

<style scoped lang="scss">
.swiper-container {
  width: 100%;
  height: 100vh;
  margin-left: auto;
  margin-right: auto;
}
.swiper-pagination /deep/ .swiper-pagination-bullet {
  background: #fff;
  width: 6px;
  height: 6px;
  margin: 15px 10px;
  opacity: 1;
}
.swiper-pagination /deep/ .swiper-pagination-bullet-active {
  width: 6px;
  height: 6px;
  position: relative;
}
.swiper-pagination /deep/ .swiper-pagination-bullet-active:before {
  content: '';
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 100%;
  border: 1px solid #fff;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.swiper-slide {
  background: #fff;
  width: 100%;
  height: 100vh;
}
.swiper-slide-1 {
  background: url('../../assets/images-front/about-banner-1.jpg') center center no-repeat;
  background-size: cover;
  transform: translateZ(0);
}
.swiper-slide-2 {
  background: url('../../assets/images-front/about-banner-2.jpg') center center no-repeat;
  background-size: cover;
  transform: translateZ(0);
}
.swiper-slide .main {
  transform: translateZ(0);
  display: block;
}
.swiper-slide-1 .content,
.swiper-slide-2 .content {
  width: 666px;
  height: 406px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: url('../../assets/images-front/about-banner-block-bg.png');
  box-sizing: border-box;
}
.swiper-slide-1 .content {
  padding: 70px 80px 0 80px;
  color: #333;
}
.swiper-slide-1 .tt {
  font-size: 30px;
  margin-bottom: 30px;
}
.swiper-slide-1 .desc {
  line-height: 2;
  letter-spacing: 1px;
  color: #666;
}
.swiper-slide-2 .content {
  padding: 70px 120px 0;
}
.swiper-slide-2 .tt {
  font-size: 30px;
  margin-bottom: 30px;
}
.swiper-slide-2 .row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 60px;
}
.swiper-slide-2 .row-tt {
  font-size: 20px;
  margin-bottom: 10px;
}
.swiper-slide-2 .row-desc {
  font-size: 18px;
  position: relative;
  color: #666;
}
.swiper-slide-2 .row-desc:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -8px;
  width: 100%;
  height: 1px;
  background: #666;
}
.swiper-slide-2 .address {
  font-size: 20px;
  margin-bottom: 10px;
}
.swiper-slide-2 .address-desc {
  color: #666;
}
</style>
